import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import QuollWordmark from '/src/assets/Quoll-Wordmark.svg';
import AddressSearch from '/src/Components/AddressSearch/AddressSearch';
import { CircleUser } from 'lucide-react';
import GetPageRoutes from '/src/services/Content/GetPageRoutes';
import { AddressSearchContext, WindowSizeContext } from '/src/App';

import './style.css';

const PageFooter = ({ onHomePage }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isHomePage = location.pathname === '/';
    const [isHeroVisible, setIsHeroVisible] = useState(true);

    const { deviceType } = useContext(WindowSizeContext);

    // Check the saved user in local storage and if they are logged in
    const savedUser = localStorage.getItem('user');
    const user = savedUser ? JSON.parse(savedUser) : null;
    const isLoggedIn = user && !user.isAnonymous;

    const pageRoutes = GetPageRoutes();
    const footerRoutes = pageRoutes.footer;


    const handleLogoClick = () => {
        if (window.location.pathname !== '/') {
            navigate('/');
        }
    }

    const handleRouteClick = (path) => {
        // Handle sitemap.xml as a direct link, not a React route
        if (path === '/sitemap.xml') {
            window.open(path, '_blank');
            return;
        }
        navigate(path);
    }

    return (
        <div className={`page-footer-container ${onHomePage ? 'page-footer-home-page' : ''} ${deviceType}`}>
            <div className="page-footer-logo-copyright-container">
                <div className={`page-header-logo-container ${deviceType}`}>
                    <img
                        src={QuollWordmark}
                        alt="Quoll Intelligence Logo"
                        className="page-header-logo"
                        onClick={handleLogoClick}
                    />
                </div>
                <span className="page-footer-copyright-symbol">&#169; 2026 Quoll Intelligence</span>
                <span className="page-footer-copyright-symbol">All Rights Reserved.</span>
            </div>

            <div className={`page-footer-routes-container ${deviceType}`}>
                {footerRoutes.map((route) => (
                    <div key={route.path} className={`page-footer-route ${deviceType}`}>
                        <span className="page-footer-route-label">
                            {route.path === '/sitemap.xml' ? (
                                <a href={route.path} target="_blank" rel="noopener noreferrer">
                                    {route.label}
                                </a>
                            ) : (
                                <Link to={route.path} onClick={() => handleRouteClick(route.path)}>
                                    {route.label}
                                </Link>
                            )}
                        </span>
                        {/* <span className="page-footer-route-label" onClick={() => handleRouteClick(route.path)}>
                            {route.label}
                        </span> */}
                    </div>
                ))}

            </div>
        </div>
    );
};

export default PageFooter;